import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { Card, Typography } from '@otp/ui';
import { Config, Settings } from '@otp/icons';
import styles from './index.module.css';
import { useDeviceContext } from 'src/context/device.context';
import { Routes } from 'src/components/common/router/constants';
import { Actions, StoreModel, Subjects } from 'src/graphql/generated/graphql';
import { Link } from 'src/components/common/link';
import { AppArea } from 'src/graphql/generated/graphql';
import { useCan } from 'src/utils/can';

type RestaurantActionsProps = {
  store: Partial<StoreModel>;
};

export const RestaurantActions = ({ store }: RestaurantActionsProps) => {
  const { isMobile } = useDeviceContext();
  const { can } = useCan();

  const { t } = useTranslation(undefined, {
    keyPrefix: 'manage-restaurants.actions',
  });

  const actionsList = [
    {
      label: t('rrm'),
      linkProps: {
        to: '',
      },
      canAccess: can({
        action: Actions.Read,
        subject: Subjects.Tools,
        appArea: AppArea.Common,
        data: {
          id: 'RRM',
        },
      }),
    },
    {
      label: t('most'),
      linkProps: {
        to: Routes.mostBase.path,
        queryParams: { filter: { storeIds: [store.id] } },
      },
      canAccess: can({
        action: Actions.Read,
        subject: Subjects.History,
        appArea: AppArea.Most,
      }),
    },
    {
      label: t('wttp'),
      linkProps: {
        to: Routes.wttpConfiguration.path,
      },
      canAccess: can({
        action: Actions.Read,
        subject: Subjects.Wttp,
        appArea: AppArea.Wttp,
      }),
    },
    {
      label: t('initiative-forms'),
      linkProps: {
        to: '',
      },
      canAccess: can({
        action: Actions.Read,
        subject: Subjects.Admin,
        appArea: AppArea.Common,
      }),
    },
    {
      label: t('initiative-forms-report'),
      linkProps: {
        to: '',
      },
      canAccess: can({
        action: Actions.Read,
        subject: Subjects.Admin,
        appArea: AppArea.Common,
      }),
    },
    {
      label: t('initiative-forms-progress-result'),
      linkProps: {
        to: '',
      },
      canAccess: can({
        action: Actions.Read,
        subject: Subjects.Admin,
        appArea: AppArea.Common,
      }),
    },
  ];

  return (
    <>
      {!isMobile && (
        <Typography variant="subtitle1" className="pt-4 flex">
          <Settings className="pr-2" />
          {t('title')}
        </Typography>
      )}
      <div
        className={clsx(
          styles.actionListWrapper,
          'grid lg:grid-cols-2 gap-1 w-full',
        )}
      >
        {actionsList.map(
          (action, index) =>
            action.canAccess && (
              <Link className="p-1 w-full" {...action.linkProps}>
                <Card
                  className={clsx(
                    'w-full h-full',
                    `hover:bg-[var(--mui-palette-primary-200)]`,
                  )}
                >
                  <div className="grid grid-cols-12 items-center">
                    <Typography variant="subtitle2" className="col-span-11">
                      {action.label}
                    </Typography>
                    <Config className={clsx('col-span-1', styles.iconColor)} />
                  </div>
                </Card>
              </Link>
            ),
        )}
      </div>
    </>
  );
};
